import React, { useEffect, useRef } from 'react';
import styles from '../components/Fleet/Modal.module.css';
import closeButton from "../static_files/closeButtonHover.svg";
import congratulationIcon from "../static_files/point icon.svg";

const FirstTimeModal = ({isOpen, onClose}) => {
    const canvasRef = useRef(null);
    const animationRef = useRef(null);
    const particlesRef = useRef([]);

    useEffect(() => {
        if (!isOpen) return;

        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#FFD93D', '#6BCF7F', '#E056FD'];

        class Confetti {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height - canvas.height;
                this.w = Math.random() * 10 + 5;
                this.h = Math.random() * 5 + 3;
                this.color = colors[Math.floor(Math.random() * colors.length)];
                this.speed = Math.random() * 3 + 2;
                this.velX = Math.random() * 2 - 1;
                this.angle = Math.random() * 360;
                this.angleSpeed = Math.random() * 0.2 - 0.1;
                this.opacity = 1;
                this.isDead = false;
            }

            update() {
                this.y += this.speed;
                this.x += this.velX;
                this.angle += this.angleSpeed;

                if (this.y > canvas.height * 0.7) {
                    this.opacity = Math.max(0, 1 - (this.y - canvas.height * 0.7) / (canvas.height * 0.3));
                }

                if (this.y > canvas.height + this.h && this.opacity <= 0) {
                    this.isDead = true;
                }
            }

            draw(ctx) {
                ctx.save();
                ctx.translate(this.x + this.w / 2, this.y + this.h / 2);
                ctx.rotate(this.angle);
                ctx.globalAlpha = this.opacity;
                ctx.fillStyle = this.color;
                ctx.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
                ctx.restore();
            }
        }

        particlesRef.current = [];
        for (let i = 0; i < 150; i++) {
            particlesRef.current.push(new Confetti());
        }

        let startTime = Date.now();
        const duration = 8000;

        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            const elapsed = Date.now() - startTime;

            particlesRef.current.forEach(particle => {
                particle.update();
                particle.draw(ctx);
            });

            particlesRef.current = particlesRef.current.filter(particle => !particle.isDead);

            if (elapsed < 3000 && particlesRef.current.length < 200) {
                for (let i = 0; i < 2; i++) {
                    particlesRef.current.push(new Confetti());
                }
            }

            if (elapsed < duration && (particlesRef.current.length > 0 || elapsed < 6000)) {
                animationRef.current = requestAnimationFrame(animate);
            } else {
                onClose();
            }
        }

        animate();

        const handleResize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        window.addEventListener('resize', handleResize);

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
            window.removeEventListener('resize', handleResize);
            particlesRef.current = [];
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <canvas
                ref={canvasRef}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                    zIndex: 1002
                }}
            />

            <div
                className={`${styles.modalContainer} ${styles.upgradeModalContainer}`}
                onClick={(e) => e.stopPropagation()}
                style={{ position: 'relative', zIndex: 1001 }}
            >
                <div className={styles.headerRow} style={{marginBottom:'0'}}>
                    <img src={closeButton} className={styles.closeBtn} onClick={onClose} alt='Close modal'/>
                </div>
                <div className={styles.successContentOuter}>

                    <div className={styles.successContent}>
                        {/* Trophy/Box Icon */}
                        <div style={{marginBottom: '24px'}}>
                            <img src={congratulationIcon}  style={{width: '30px'}} alt="points"/>
                        </div>

                        <h2 className={styles.successTitle}>Congratulations!</h2>

                        <div style={{textAlign: 'center', marginTop: '16px', marginBottom: '8px'}}>
                            <p style={{
                                color: '#FFFFFF',
                                fontSize: '18px',
                                fontWeight: '400',
                                lineHeight: '28px',
                                margin: '0'
                            }}>
                                You're now a <span style={{color: '#6CE3C4'}}>PrismaX Explorer</span>.
                            </p>
                            <p style={{
                                color: '#FFFFFF',
                                fontSize: '18px',
                                fontWeight: '400',
                                lineHeight: '28px',
                                margin: '0'
                            }}>
                                Here are <span style={{color: '#6CE3C4'}}>1,000</span> Prisma Points to get you started!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FirstTimeModal;